/**
 * Бейдж статуса переносной единицы (фаза 4, equipment_mobility_plan.md).
 *
 * Статус приходит с сервера уже итоговым (services/equipmentStatus.js
 * effectiveStatus): хранимый «Готова / В аренде / На приёмке» или выведенный из
 * Работ «Неисправна» (открытая экстренная Работа) / «На обслуживании»
 * (открытая Работа на Складе). Здесь только цвет и подпись.
 *
 * Один компонент на карточку, список Объекта и «Парк» — чтобы один и тот же
 * статус везде выглядел одинаково.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';

// Цвет несёт смысл: зелёный — можно выдавать, красный — простой у клиента.
export const STATUS_COLORS = {
  ready:      { bg: 'rgba(22,163,74,0.12)',  fg: '#15803d' },
  on_hire:    { bg: 'rgba(37,99,235,0.12)',  fg: '#1d4ed8' },
  breakdown:  { bg: 'rgba(220,38,38,0.12)',  fg: '#b91c1c' },
  off_hire:   { bg: 'rgba(217,119,6,0.14)',  fg: '#b45309' },
  in_service: { bg: 'rgba(234,88,12,0.12)',  fg: '#c2410c' },
  unknown:    { bg: 'rgba(100,116,139,0.14)', fg: '#475569' },
};

export default function EquipmentStatusBadge({ status, style }) {
  const { t } = useTranslation();
  if (!status || !STATUS_COLORS[status]) return null;
  const c = STATUS_COLORS[status];
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 5,
      fontSize: 11, fontWeight: 700, padding: '2px 8px', borderRadius: 6,
      background: c.bg, color: c.fg, whiteSpace: 'nowrap', ...style,
    }}>
      <span style={{ width: 6, height: 6, borderRadius: '50%', background: c.fg }} />
      {t(`equipmentStatus.${status}`)}
    </span>
  );
}
